import script from "./EmailConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./EmailConfirmation.vue?vue&type=style&index=0&id=973a7086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-973a7086"]])

export default __exports__